<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">Słownik - Kaper Rejestr VAT</h1>

    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="px-6 pt-6 pb-4">Nazwa rejestru</th>
          <th class="px-6 pt-6 pb-4">Wariant VAT-7</th>
          <th class="px-6 pt-6 pb-4">Dokumenty</th>
          <th class="px-6 pt-6 pb-4">Przenies z KPR</th>
          <th class="px-6 pt-6 pb-4">VAT marża</th>
          <th class="px-6 pt-6 pb-4">Aktywny</th>
        </tr>
        <tr v-for="rejestr in rejestry" :key="rejestr.id" class="hover:bg-gray-100 focus-within:bg-gray-100" :class="{'bg-red-50':!rejestr.active}">
          <td class="border-t">
            <span class="px-6 py-4 flex items-center focus:text-shtax-500 whitespace-normal">
              {{ rejestr.nazwa }}
            </span>
          </td>
          <td class="border-t">
            <span class="px-6 py-4 flex items-center focus:text-shtax-500">
              {{ rejestr.wariant_vat7_text }}
            </span>
          </td>
          <td class="border-t">
            <span class="px-6 py-4 flex items-center focus:text-shtax-500">
              {{ rejestr.rodzaj_dokumentu_text }}
            </span>
          </td>
          <td class="border-t">
            <span class="px-6 py-4 flex items-center focus:text-shtax-500">
              {{ rejestr.przeniesienie_zapisu_text }}
            </span>
          </td>
          <td class="border-t">
            <span class="px-6 py-4 flex items-end focus:text-shtax-500">
              {{ rejestr.marza == 1 ? 'Tak' : 'Nie' }}
            </span>
          </td>
          <td class="border-t">
            <span class="px-6 py-4 flex items-end focus:text-shtax-500">
              {{ rejestr.active ? 'Tak' : 'Nie' }}
            </span>
          </td>
        </tr>
        <tr v-if="rejestry.length === 0">
          <td class="border-t px-6 py-4" colspan="6">Nie znaleziono rejestrów.</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'

export default {
  metaInfo: { title: 'Słownik - Kaper Rejestr VAT' },
  components: {
  },
  layout: Layout,
  props: {
    rejestry: Array
  },
  data() {
    return {
    }
  }
}
</script>
